module.exports = __webpack_public_path__ + "static/media/2017.bcfba5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2017.png
// module id = 608
// module chunks = 0